import { lazy } from 'react';
import { Outlet, type RouteObject } from 'react-router-dom';

import PageWrapper from './PageWrapper';

const PublicLessonQrAttendancePage = lazy(() => import('@/pages/public/lesson-attendance/qr/Page'));
const TermsPage = lazy(() => import('@/pages/public/terms/Page'));
const PrivacyPage = lazy(() => import('@/pages/public/privacy/Page'));
const SupportPage = lazy(() => import('@/pages/public/support/Page'));
const ZoomPage = lazy(() => import('@/pages/public/zoom/Page'));

export const publicRoutes: RouteObject = {
  path: 'public',
  element: <Outlet />,
  children: [
    {
      path: 'lesson-attendance/qr/:lessonSessionId',
      element: (
        <PageWrapper>
          <PublicLessonQrAttendancePage />
        </PageWrapper>
      ),
    },
    {
      path: 'terms',
      element: (
        <PageWrapper>
          <TermsPage />
        </PageWrapper>
      ),
    },
    {
      path: 'privacy',
      element: (
        <PageWrapper>
          <PrivacyPage />
        </PageWrapper>
      ),
    },
    {
      path: 'support',
      element: (
        <PageWrapper>
          <SupportPage />
        </PageWrapper>
      ),
    },
    {
      path: 'zoom',
      element: (
        <PageWrapper>
          <ZoomPage />
        </PageWrapper>
      ),
    },
  ],
};
